import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import CanScene from "@/components/three/CanScene";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Anatomy from "@/components/site/Anatomy";
import Spark from "@/components/site/Spark";
import Founder from "@/components/site/Founder";
import Journey from "@/components/site/Journey";
import Showcase from "@/components/site/Showcase";
import Proof from "@/components/site/Proof";
import Footer from "@/components/site/Footer";
import AudioToggle from "@/components/site/AudioToggle";
import AgeGate from "@/components/site/AgeGate";
import MountainBand from "@/components/site/MountainBand";
import FindUs from "@/components/site/FindUs";
import { useLenis } from "@/lib/smooth";
import { fizz } from "@/lib/audio";

const AGE_KEY = "hh_age_ok";

function App() {
  const [ageOk, setAgeOk] = useState(() => localStorage.getItem(AGE_KEY) === "1");
  useLenis();

  useEffect(() => {
    const l = window.__lenis;
    if (!l) return;
    if (ageOk) l.start();
    else l.stop();
  }, [ageOk]);

  useEffect(() => {
    const on = (e) => {
      if (e.target instanceof Element && e.target.closest("button,a")) fizz(0.5);
    };
    window.addEventListener("pointerdown", on);
    return () => window.removeEventListener("pointerdown", on);
  }, []);

  const confirmAge = () => {
    localStorage.setItem(AGE_KEY, "1");
    setAgeOk(true);
  };

  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <CanScene />
      <Nav />
      <main>
        <Hero ready={ageOk} />
        <Marquee />
        <Anatomy />
        <MountainBand id="craft" label="Crafted in the Himalayas" />
        <Spark />
        <Founder />
        <Journey />
        <Showcase />
        <MountainBand id="orchard" label="From Himachal's orchards to your glass" />
        <Proof />
        <FindUs />
      </main>
      <Footer />
      <AudioToggle />
      {!ageOk && <AgeGate onConfirm={confirmAge} />}
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
